import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-do-more-games',
  templateUrl: './do-more-games.component.html',
  styleUrls: ['./do-more-games.component.css']
})
export class DoMoreGamesComponent implements OnInit {

  constructor(private router: Router, private authService: AuthService) { }

  ngOnInit(): void {
  }

  onJoinNow(): void {
    const isLoggedIn = !!this.authService.userValue;
    this.router.navigate([isLoggedIn ? '/profile' : '/login']);
  }

}
